import {
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import react, { useEffect, useState } from "react";
import up from "../Assets/dashcard/upgraph.svg";
import "../Style/Component/Dashgraph.css";
import Select from "react-select";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api";
import { ChartSkeleton } from "./Skeleton";
const Dashgraph = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const [gvalues, setGvalues] = useState([]);
  const currentYear = new Date().getFullYear();
  const [month, setMonth] = useState({
    value: "All",
    label: "All",
  });

  const [year, setYear] = useState({
    value: currentYear,
    label: `${currentYear}`,
  });
  const startYear = 2020;
  const endYear = currentYear + 1;
  const [loading, setLoading] = useState(false);
  const yearoptions = [
    ...Array.from(
      { length: endYear - startYear + 1 },
      (_, i) => endYear - i,
    ).map((year) => ({
      value: year,
      label: `${year}`,
    })),
  ];
  const monthoptions = [
    { value: "All", label: "All" },
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  useEffect(() => {
    const fetchgraphvalues = async () => {
      try {
        setLoading(true);
        const response = await getWithTokenAPI(
          token,
          `/dashboard/login-details?year=${year.value}&month=${month.value}`,
        );
        if (response?.data) {
          setGvalues(response?.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchgraphvalues();
  }, [token, year, month]);

  const chartData =
    month.value === "All"
      ? (gvalues?.months || []).map(
          ({ month, totalCustomers, totalDrivers }) => ({
            month,
            customers: totalCustomers,
            drivers: totalDrivers,
          }),
        )
      : (gvalues?.days || []).map(({ day, totalCustomers, totalDrivers }) => ({
          month: day, // use day instead of month if it's day-wise
          customers: totalCustomers,
          drivers: totalDrivers,
        }));

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: "36px",
      width: "160px", // ✅ fixed width
      minWidth: "160px",
      maxWidth: "160px",
      border: "0.6px solid #dcdcdc",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(74, 144, 226, 0.2)" : "none",
      borderColor: state.isFocused ? "#4a90e2" : "#dcdcdc",
      "&:hover": {
        borderColor: "#999",
      },
      backgroundColor: "white",
    }),
    option: (base, state) => {
      const isSelected = state.isSelected;
      const isFocused = state.isFocused;

      return {
        ...base,
        backgroundColor: isSelected
          ? "#013A28" // ✅ selected always wins
          : isFocused
            ? "#02543a53" // hover only for non-selected
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",

        // ❌ disable hover override on selected
        ":hover": {
          backgroundColor: isSelected ? "#013A28" : "#02543a53",
        },

        ":active": {
          backgroundColor: isSelected ? "#013A28" : "#02543a53",
        },
      };
    },

    menu: (base) => ({
      ...base,
      borderRadius: "4px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      zIndex: "99 !important",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflow: "auto",
      // Scrollbar matching your #8C1007 theme
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a284a",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2840",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#013a2851",
      },
      scrollbarWidth: "thin",
      scrollbarColor: "#02543a53 #b0b0b06a",
    }),
    singleValue: (base) => ({
      ...base,
      color: "rgb(99, 99, 99)", // Matching your color
      fontSize: "14px",
      fontWeight: "500",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#acacac",
      fontSize: "14px",
      fontWeight: "500",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#8c8c8c",
      padding: "4px 8px",
      "&:hover": {
        color: "#666",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 5px",
    }),
  };
  if (loading) return <ChartSkeleton />;
  return (
    <div className="dashgraph">
      <div className="graph-header">
        <span className="badge">Log In Details</span>

        <div className="filters">
          <select>
            <option>Customer & Driver Details</option>
          </select>
          {/* <select>
              <option>12 Months</option>
            </select>
            <select>
              <option>2025</option>
            </select> */}

          {/* CITY */}
          <Select
            options={monthoptions}
            value={month}
            onChange={(selected) => setMonth(selected)}
            styles={customStyles}
            isSearchable={false}
            placeholder="Select Month"
            // components={{
            //   SingleValue: SingleValueWithLabel("City"),
            //   Placeholder: PlaceholderWithLabel("City"),
            //   IndicatorSeparator: null,
            // }}
          />

          {/* AREA */}
          <Select
            options={yearoptions}
            value={year}
            onChange={(selected) => setYear(selected)}
            styles={customStyles}
            isSearchable={false}
            placeholder={currentYear}
            // components={{
            //   SingleValue: SingleValueWithLabel("Area"),
            //   Placeholder: PlaceholderWithLabel("Area"),
            //   IndicatorSeparator: null,
            // }}
          />
        </div>
      </div>
      <div className="graph-bottom">
        <div className="graph-card">
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={chartData}>
              <defs>
                <linearGradient
                  id="customerGradient"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor="#6BCF63" stopOpacity={0.4} />
                  <stop offset="100%" stopColor="#6BCF63" stopOpacity={0.05} />
                </linearGradient>
              </defs>

              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />

              <Area
                type="monotone"
                dataKey="customers"
                stroke="#6BCF63"
                fill="url(#customerGradient)"
              />

              <Line
                type="monotone"
                dataKey="drivers"
                stroke="#E53935"
                strokeWidth={2}
                dot={{ r: 4 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div>
          <div className="summary">
            <div className="summary-card">
              <p className="title">Top month</p>
              <img src={up}></img>
              <h3>{gvalues?.topMonth?.month || "Jan"}</h3>
              <span>{currentYear}</span>
            </div>

            <div className="summary-card">
              <p className="title">Top year</p>
              <img src={up}></img>
              <h3>{gvalues?.topYear?.year || "2026"}</h3>
              <span>{gvalues?.topYear?.totalCustomers} Customers so far</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashgraph;
